import React from "react";
import { GridOverlay } from "@mui/x-data-grid";

const CustomNoRowsOverlay = () => {
  return (
    <GridOverlay>
      <div
        style={{
          minHeight: "100px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        No data found
      </div>
    </GridOverlay>
  );
};

export default CustomNoRowsOverlay;
